<template>
    <div class="media-uploader-container">
        <p class="title">Select Profile Image</p>
        <div class="media-uploader-wrapper">
            <div v-if="medias.length" class="media-display">
                <img
                    v-for="(media, indx) in medias"
                    :key="indx"
                    :src="previewSrc(media)"
                    @click="handleSelectProfileImg(indx)"
                    class="uploaded-media"
                    :class="indx === profileImgIndx ? 'selected-uploaded-media' : ''"
                    alt="media-img"
                />
            </div>
            <input
                ref="mediaUploadEl"
                type="file"
                @change="handleMediaUpload"
                accept="video/*,image/*"
                hidden="hidden"
            />
            <button
                @click="handleUploadMedia"
                :class="medias.length ? 'media-upload-btn' : 'media-upload-btn-wide'"
            >
                <img
                    :src="URLS.icons.mediaUploadBtn"
                    class="upload-btn"
                    alt="upload-media-btn"
                />
                <p class="upload-msg">Upload</p>
            </button>
        </div>
    </div>
</template>
<script>
    import { useMediaUploader } from '@/composables/ui/useMediaUploader'
    export default {
        name: 'MediaUploader',
        setup() {
            const {
                URLS,
                mediaUploadEl,
                medias,
                profileImgIndx,
                previewSrc,
                handleMediaUpload,
                handleUploadMedia,
                handleSelectProfileImg
            } = useMediaUploader()

            return {
                URLS,
                mediaUploadEl,
                medias,
                profileImgIndx,
                previewSrc,
                handleMediaUpload,
                handleUploadMedia,
                handleSelectProfileImg
            }
        }
    }
</script>
<style lang="scss" scoped>
    $mobileMax: 600px;
    @media screen and (max-width: $mobileMax) {
        .media-upload-btn-wide {
            width: 100% !important;
            min-width: 320px !important;
        }
    }

    .media-uploader-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 6px;

        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }
        .title {
            color: #8b8b8b;
            font-family: Instrument Sans;
            font-size: 12px;
            font-style: normal;
            font-weight: 650;
            line-height: 135%;
            letter-spacing: 0.12px;
            align-self: flex-start;
        }
        .media-uploader-wrapper {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: center;
            gap: 12px;

            .media-display {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                gap: 12px;
                flex-wrap: wrap;

                .uploaded-media {
                    border-radius: 12px;
                    width: 66px;
                    height: 66px;
                    object-fit: cover;
                    cursor: pointer;
                    filter: blur(1px);
                }
                .selected-uploaded-media {
                    border: 1px solid #cdeb09;
                    filter: none;
                }
            }
            .media-upload-btn,
            .media-upload-btn-wide {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 4px;
                border-radius: 12px;
                border: 1px solid #8b8b8b;
                max-width: 66px;
                min-width: 66px;
                height: 66px;
                background: inherit;

                .upload-btn {
                    width: 18px;
                    height: 18px;
                    object-fit: cover;
                }
                .upload-msg {
                    color: #8b8b8b;
                    font-family: Instrument Sans;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 650;
                    line-height: 135%;
                    letter-spacing: 0.12px;
                }
            }
            .media-upload-btn-wide {
                width: 460px;
                max-width: none;
            }
        }
    }
</style>
